var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13391_4267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.003033 5.6003 -0.13559 7.00777 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C13.998 5.1441 13.2599 3.36479 11.9475 2.05247C10.6352 0.74015 8.8559 0.0020073 7 0ZM7 12.8333C5.84628 12.8333 4.71846 12.4912 3.75918 11.8502C2.79989 11.2093 2.05222 10.2982 1.61071 9.23232C1.16919 8.16642 1.05368 6.99353 1.27876 5.86197C1.50384 4.73042 2.05941 3.69102 2.87521 2.87521C3.69102 2.0594 4.73042 1.50383 5.86198 1.27875C6.99353 1.05367 8.16642 1.16919 9.23232 1.6107C10.2982 2.05221 11.2093 2.79989 11.8502 3.75917C12.4912 4.71846 12.8333 5.84628 12.8333 7C12.8316 8.54658 12.2165 10.0293 11.1229 11.1229C10.0293 12.2165 8.54658 12.8316 7 12.8333Z",
    fill: "#A5A5A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 5.83331H6.41634C6.26163 5.83331 6.11326 5.89477 6.00386 6.00417C5.89447 6.11356 5.83301 6.26194 5.83301 6.41665C5.83301 6.57136 5.89447 6.71973 6.00386 6.82913C6.11326 6.93852 6.26163 6.99998 6.41634 6.99998H6.99967V10.5C6.99967 10.6547 7.06113 10.8031 7.17053 10.9125C7.27993 11.0219 7.4283 11.0833 7.58301 11.0833C7.73772 11.0833 7.88609 11.0219 7.99549 10.9125C8.10488 10.8031 8.16634 10.6547 8.16634 10.5V6.99998C8.16634 6.69056 8.04342 6.39381 7.82463 6.17502C7.60584 5.95623 7.30909 5.83331 6.99967 5.83331Z",
    fill: "#A5A5A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66669C7.48325 4.66669 7.875 4.27494 7.875 3.79169C7.875 3.30844 7.48325 2.91669 7 2.91669C6.51675 2.91669 6.125 3.30844 6.125 3.79169C6.125 4.27494 6.51675 4.66669 7 4.66669Z",
    fill: "#A5A5A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13391_4267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ed2a43fc1f430c0695d83b90aaa57bcb.svg";
export { ForwardRef as ReactComponent };